import { Icon, IconProps } from '@chakra-ui/react';

export default function Coupon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 15" fill="transparent" {...props}>
      <rect
        x="0.789844"
        y="0.91875"
        width="18.4261"
        height="12.9188"
        rx="1.3"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <line
        x1="13.2174"
        y1="4.46562"
        x2="9.45656"
        y2="10.7337"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <circle cx="8.22809" cy="5.9859" r="1.18043" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="14.4976" cy="9.74567" r="1.18043" stroke="currentColor" strokeWidth="1.4" />
      <rect
        x="3.49411"
        y="3.79489"
        width="0.550725"
        height="0.550725"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="0.550725"
      />
      <rect
        x="3.49411"
        y="5.99411"
        width="0.550725"
        height="0.550725"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="0.550725"
      />
      <rect
        x="3.49411"
        y="8.20114"
        width="0.550725"
        height="0.550725"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="0.550725"
      />
      <rect
        x="3.49411"
        y="10.4004"
        width="0.550725"
        height="0.550725"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="0.550725"
      />
    </Icon>
  );
}
